// extracted by mini-css-extract-plugin
module.exports = {"footerStyle":"Footer_footerStyle__wf4YK","footerContant":"Footer_footerContant__1gpwy"};